import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PulseNpsBreakdownComponent } from './pulse-nps-breakdown.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { AlertBannerModule } from '../../lib/alert-banner';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({ declarations: [PulseNpsBreakdownComponent],
    exports: [PulseNpsBreakdownComponent], imports: [CommonModule,
        HighchartsChartModule,
        AlertBannerModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class PulseNpsBreakdownModule {}
